import { curry } from 'ramda';

export default curry(function (len, data) {
  return data >= len;
});